$(document).ready(() => {

  $('.product-item').on('click', function(){

    $(this).parents('.product--container').find('.product-item.active').removeClass('active');
    $(this).addClass('active');
    
    if ($(this).hasClass('soldout')) {
      $(this).parents('.product--container').find('form>button[type="submit"]').attr('disabled', 'disabled');
      $(this).parents('.product--container').find('form>button[type="submit"]').addClass('soldout');
      $(this).parents('.product--container').find('form>button[type="submit"]').text('Sold Out');
      return;
    };

    $(this).parents('.product--container').find('form>button[type="submit"]').removeAttr('disabled');
    $(this).parents('.product--container').find('form>button[type="submit"]').removeClass('soldout');
    $(this).parents('.product--container').find('form>button[type="submit"]').text('Add To Cart');
    
    const variantId = $(this).data('id');
    $(this).parents('.product--container').find('form>input').attr('value', variantId);
  })
})